import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/deployments/overview")({
  component: () => <Navigate to="/$" params={{ _splat: "deployments" }} replace />,
});
